export const positionAtAngle = (start: any, degree: any, scale: any) => {
  const position = {
    x: scale * Math.cos(Math.PI * (degree - 90) / 180),
    y: scale * Math.sin(Math.PI * (degree - 90) / 180)
  }

  return position
}
